import React, { useState, useEffect, useCallback } from 'react';
import './ExchangeRateSection.css';

const API_URL = process.env.REACT_APP_API_URL || '/api';

const ExchangeRateSection = ({ user }) => {
  const [rates, setRates] = useState([]);
  const [editValues, setEditValues] = useState({});
  const [saving, setSaving] = useState(false);

  const fetchRates = useCallback(async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${API_URL}/exchange-rates`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.ok) {
        const data = await res.json();
        setRates(data);
        const values = {};
        data.forEach((r) => { values[r.key] = String(r.rate); });
        setEditValues(values);
      }
    } catch (err) {
      console.error('載入匯率失敗', err);
    }
  }, []);

  useEffect(() => { fetchRates(); }, [fetchRates]);

  const handleChange = (key, value) => {
    if (value === '' || /^\d*\.?\d*$/.test(value)) {
      setEditValues((prev) => ({ ...prev, [key]: value }));
    }
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      const token = localStorage.getItem('token');
      const payload = Object.entries(editValues).map(([key, rate]) => ({
        key,
        rate: parseFloat(rate) || 0,
      }));
      const res = await fetch(`${API_URL}/exchange-rates`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ rates: payload }),
      });
      if (res.ok) {
        const data = await res.json();
        setRates(data);
      }
    } catch (err) {
      console.error('儲存匯率失敗', err);
    } finally {
      setSaving(false);
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '尚未設定';
    const d = new Date(dateStr);
    return d.toLocaleString('zh-TW', {
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit',
    });
  };

  const isManager = user?.role === 'manager';

  return (
    <section className="section exchange-rate-section">
      <div className="section-header">
        <h2>
          <span className="section-number">1</span>
          當前匯率
        </h2>
      </div>
      <div className="rate-grid">
        {rates.map((r) => (
          <div key={r.key} className="rate-item">
            <div className="form-group">
              <label>{r.label}</label>
              <div className="rate-input-wrapper">
                <input
                  type="text"
                  inputMode="decimal"
                  className="form-control"
                  value={editValues[r.key] ?? ''}
                  onChange={(e) => handleChange(r.key, e.target.value)}
                  disabled={!isManager}
                />
                <span className="rate-unit">{r.unit}</span>
              </div>
              <span className="rate-updated">最後更新：{formatDate(r.updatedAt)}</span>
            </div>
          </div>
        ))}
      </div>
      {isManager && (
        <div className="rate-actions">
          <button className="btn btn-primary btn-sm" onClick={handleSave} disabled={saving}>
            {saving ? '儲存中...' : '儲存匯率'}
          </button>
        </div>
      )}
    </section>
  );
};

export default ExchangeRateSection;
